import { render, staticRenderFns } from "./UpgradeAppModal.vue?vue&type=template&id=4b08a08e&scoped=true&"
import script from "./UpgradeAppModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeAppModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeAppModal.vue?vue&type=style&index=0&id=4b08a08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08a08e",
  null
  
)

export default component.exports